<template>
  <div class="font-normal w-full">
    <div class="mb-6">
      <div class="flex items-center">
        <span class="ml-4 cursor-pointer" test-id="goBackButton" @click="goBack"
          ><i
            class="el-icon-arrow-left font-extrabold text-4xl text-black-2 mt-4 mr-3"
          ></i
        ></span>
        <div class="text-black font-bold md:text-xl mt-4">
          Deposit instructions
        </div>
      </div>
      <span class="text-black-2 text-sm font-normal ml-16">Wire transfer</span>
    </div>

    <div class="mx-4">
      <el-form
        label-position="top"
        :model="wireTransferForm"
        ref="wireTransferForm"
        label-width="80px"
        size="normal"
      >
        <el-form-item prop="amount" class="mb-4">
          <div class="my-2">
            <span class="ml-5 text-black-2 md:text-xl">Select</span>
            <el-radio-group
              v-model="wireTransferForm.type"
              class="grid gap-5 text-black-2"
            >
              <el-radio
                label="Within The United States"
                class="mr-0 border p-3 md:p-5 rounded-xl"
                :class="
                  wireTransferForm.type === 'Within The United States'
                    ? 'border-primary'
                    : ' border-gray-5'
                "
              ></el-radio>
              <el-radio
                label="International Transfer"
                class="border p-3 md:p-5 rounded-xl"
                :class="
                  wireTransferForm.type === 'International Transfer'
                    ? 'border-primary'
                    : ' border-gray-5'
                "
              >
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <div class="text-gray-10 italic text-xs mx-4 mb-4">
          <div>
            <span> <i class="el-icon-s-opportunity text-gray-11"></i></span>Tips
            & Note:
          </div>
          <div class="mt-4">
            <p>1. Ensure you use the correct reference.</p>
            <p>2. Also know that this process takes about 2-4 business days.</p>
          </div>
        </div>
        <el-form-item class="mt-6 mb-4">
          <o-button :disabled="!wireTransferForm.type" @click="showAccountInfo"
            >Next</o-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wireTransferForm: {
        type: ''
      }
    }
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    },
    showAccountInfo () {
      this.$store.dispatch(
        'transactions/wireTransferType',
        this.wireTransferForm.type
      )
      this.$emit('showAccountInfo')
    }
  },
  mounted () {
    if (this.$store.state.transactions.wireTransferType) {
      this.wireTransferForm.type =
        this.$store.state.transactions.wireTransferType
    }
  }
}
</script>

<style scoped>
>>> .el-radio__input.is-checked + .el-radio__label {
  color: var(--color-primary);
}
>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: var(--color-primary);
  background: white;
}
>>> .el-radio__inner:hover {
  border-color: var(--color-primary);
}
>>> .el-radio__inner {
  width: 22px;
  height: 22px;
}
>>> .el-radio__label {
  font-size: 17px;
}
>>> .el-radio__inner::after {
  width: 15px;
  height: 15px;
  background-color: var(--color-primary);
}
>>> .el-radio__inner:hover {
  border-color: var(--color-primary);
}

>>> .el-button.is-disabled {
  background-color: #f4a177;
  color: white;
}

>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
